import React, { ReactNode } from 'react'
import {
  Box,
  Grid,
  IconButton,
  Modal as MaterialModal,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useStyles } from './styles'

/*
Copyright 2022-04-27 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Corrección en modal para que se pueda utilizar un porcentaje mayor de la ventana.

Copyright 2022-05-04 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se módifica modal para que pueda aceptar su tamano desde fuera de la implementación y
tambien se pueda modificar el id del modal.

Copyright 2022-05-06 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: se agrega posibilidad de indicar un titulo al costado de la x para cerrar ventana
*/

interface ModalProps {
  isOpen: boolean
  funcClose: () => void
  backdropClick?: boolean
  disabled?: boolean
  hideBackdrop?: boolean
  btnCloseModal?: boolean
  idDescriptor?: string
  size?: 'XS' | 'SM' | 'LG'
  title?: string
  children?: ReactNode
}

function getModalStyle() {
  const top = 50
  const left = 50

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
    maxHeight: '75%'
  }
}

export const Modal: React.FC<ModalProps> = ({
  isOpen,
  funcClose,
  backdropClick = true,
  children,
  disabled,
  hideBackdrop,
  idDescriptor = 'simple-modal-title',
  size = 'LG',
  title = ''
}) => {
  const classes = useStyles()
  const [modalStyle] = React.useState(getModalStyle)
  return (
    <div>
      <MaterialModal
        
        open={isOpen}
        onClose={funcClose}
        aria-labelledby={idDescriptor}
        aria-describedby='simple-modal-description'
        id={idDescriptor}
        hideBackdrop={hideBackdrop}
        keepMounted={false}
      >
        <div style={modalStyle} className={classes[`paper${size}`]}>
          <Grid
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'
          >
            <Grid item xs={11} sm={8}>
              <Typography variant='h5'>{title.toUpperCase()}</Typography>
            </Grid>
            <Grid item xs={1} sm={4}>
              <Box
                display='flex'
                alignContent='flex-end'
                justifyContent='flex-end'
              >
                <IconButton
                  color='primary'
                  onClick={funcClose}
                  disabled={disabled}
                >
                  <CloseIcon />
                </IconButton>
              </Box>
            </Grid>
          </Grid>

          {children}
        </div>
      </MaterialModal>
    </div>
  )
}
